module.exports = __webpack_public_path__ + "static/media/star-full-2.59580f29.svg";